import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { keyBy } from "lodash";
import {
    ADD_NEW_TPV,
    DELETE_TPV,
    TPV_FORM_TOOGLE_LOADING,
    SET_TPV_LIST,
    SHOW_NOTIFICATION,
    UPDATE_TPV,
} from "../constants";
import { formatTpvs } from "./settingsActionsUtils";

/* TPV LIST */
export const fetchTpvs = () => {
    return async (dispatch) => {
        const response = await axios
            .get(API.tpvs.list)
            .then((response) => {
                const tpvs = formatTpvs(response.data);
                dispatch({
                    type: SET_TPV_LIST,
                    payload: keyBy(tpvs, "_id"),
                });
                return response.status;
            })
            .catch((err) => err);
        return response;
    };
};

// TPVS
export const createTpv = (newTpv) => {
    return async (dispatch) => {
        dispatch({ type: TPV_FORM_TOOGLE_LOADING });
        const response = await axios
            .post(API.tpvs.create, newTpv)
            .then((response) => {
                const tpv = formatTpvs(response.data);
                dispatch({ type: ADD_NEW_TPV, payload: tpv });
                dispatch({ type: TPV_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "success",
                        message: "TPV creado con éxito.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: TPV_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const updateTpv = (updatedTpv) => {
    return async (dispatch) => {
        dispatch({ type: TPV_FORM_TOOGLE_LOADING });
        const response = await axios
            .put(`${API.tpvs.edit}${updatedTpv && updatedTpv._id}`, updatedTpv)
            .then((response) => {
                const tpv = formatTpvs(response.data);
                dispatch({ type: UPDATE_TPV, payload: tpv });
                dispatch({ type: TPV_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "TPV actualizado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: TPV_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const deleteTpvs = (Ids) => {
    return async (dispatch) => {
        dispatch({ type: TPV_FORM_TOOGLE_LOADING });
        const response = await axios
            .delete(`${API.tpvs.delete}`, { data: Ids })
            .then((response) => {
                dispatch({ type: DELETE_TPV, payload: Ids });
                dispatch({ type: TPV_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "TPV eliminado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: TPV_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};
